/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { useCallback, useState } from 'react'
import { useIntl } from 'react-intl'
import ProrataTool from './prorata/ProrataTool'
import { ActionIcon, Menu } from '@mantine/core'
import { faTools } from '@fortawesome/free-solid-svg-icons/faTools'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function ToolsMenu () {
  const intl = useIntl()
  const [isProrataModalOpen, setIsProrataModalOpen] = useState<boolean>(false)

  const toggleProrataModal = useCallback(() => {
    setIsProrataModalOpen((s) => !s)
  }, [])

  return (
    <>
      <Menu>
        <Menu.Target>
          <ActionIcon
            variant="subtle"
            radius="xl"
            size="lg"
            title={intl.formatMessage({
              id: 'tools',
              defaultMessage: 'Outils'
            })}
          >
            <FontAwesomeIcon fixedWidth icon={faTools} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown maw={200}>
          <Menu.Item onClick={toggleProrataModal}>
            {intl.formatMessage({
              id: 'prorata_calcul',
              defaultMessage: 'Calcul de prorata'
            })}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      <ProrataTool
        opened={isProrataModalOpen}
        onClose={toggleProrataModal}
      />
    </>
  )
}

export default ToolsMenu
